import React, { FC } from 'react';
import { FullHeightLoader } from '../../../common';
import styles from './ListLoadingIndicator.scss';

export const ListLoadingIndicator: FC = () => <FullHeightLoader className={styles.indicator} size="small" />;
